<template>
    <v-app>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-title pt-3 px-3 d-flex justify-content-between">
                            <div class="breadcrumb-left">
                                <h4> Upcoming exams</h4>
                                <!-- <div class="breadcrumb-sub-header">
                                    <router-link to="/dashboard">Dashboard</router-link>
                                    \ Upcoming exams
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="">
                            <v-skeleton-loader v-if="loading" type="table-thead">
                            </v-skeleton-loader>

                            <v-skeleton-loader v-if="loading" type="table-row-divider@25">
                            </v-skeleton-loader>
                            <table class="table" v-if="!loading">
                                <thead>
                                <tr class="px-3">
                                    <th class="wrap-column">Exam info</th>
                                    <th class="wrap-column px-3">Action</th>
                                </tr>
                                </thead>
                                <template>
                                <tr
                                    v-show="entranceExams.length > 0"
                                    v-for="(item, index) of entranceExams"
                                    :key="index"
                                >
                                    <td class="px-3 py-4 wrap-column">
                                        <span
                                            class="text-primary font-weight-bolder text-hover-primary mb-1">
                                            {{ item.title }} </span>&nbsp;&nbsp;
                                        <i class="fas fa-circle"
                                            :class="item.is_active ? 'dot-active' : 'dot-inactive'"></i>

                                        <div class="mt-2 text-secondary">
                                            <span class="font-weight-medium">
                                            {{ item.setting && item.setting.display_text ? item.setting.display_text : "NA" }}
                                            </span>
                                        </div>
                                    </td>
                                    
                                    <td class="pr-0">
                                    <template>
                                        <b-dropdown
                                        size="sm"
                                        variant="link"
                                        toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                                        no-caret
                                        right
                                        no-flip
                                        >
                                        <template v-slot:button-content>
                                            <i class="ki ki-bold-more-hor"></i>
                                        </template>
                                        <div class="navi navi-hover">
                                            <b-dropdown-text
                                            tag="div"
                                            class="navi-item"
                                            v-if="item.is_active"
                                            >
                                            <span
                                                href="#"
                                                @click="viewCandidates(item)"
                                                class="navi-link"
                                            >
                                                <span class="navi-icon">
                                                <i class="fa fa-users"></i>
                                                </span>
                                                <span class="navi-text"> View candidates</span>
                                            </span>
                                            </b-dropdown-text>
                                        </div>
                                        </b-dropdown>
                                    </template>
                                    </td>
                                </tr>
                                <tr v-show="entranceExams.length == 0">
                                    <td class="px-3 text-center" colspan="5">
                                    <strong>
                                        No data available to display.
                                    </strong>

                                    </td>
                                </tr>
                                </template>
                            </table>
                            <b-pagination 
                                v-show="entranceExams.length > 0" 
                                @input="getUpcomingEntranceExams" 
                                class="pull-right mt-7" 
                                v-model="page"
                                :total-rows="total" 
                                :per-page="perPage" 
                                first-number 
                                last-number
                            ></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-app>
</template>

<script>
import EntranceExamService from "@/core/services/kiosk/entrance-exam/EntranceExamService";

const entranceExam = new EntranceExamService();

export default {  
    data() {
        return {
            search: {
                title: '',
                status: '',
                date_filter_type: '',
                date: '',
                user: '',
                class: ''
            },
            menu: false,
            loading: false,
            entranceExams: [],
            page: null,
            perPage: null,
            total: null,
        }
    },
    methods: {
        searchParentMeets(){
            this.page = 1;
            this.getUpcomingEntranceExams();
        },  
        getUpcomingEntranceExams() {
            this.loading = true;
            entranceExam
                .getUpcomingEntranceExams(this.search, this.page)
                .then(response => {
                    this.entranceExams = response.data.data;
                    this.page = response.data.meta.current_page;
                    this.total = response.data.meta.total;
                    this.perPage = response.data.meta.per_page;
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                });
        },
        viewCandidates(item){
            this.$router.push({name: 'entrance-exam-candidates', params: {examId: item.id}});
        }
    },
    mounted() {
        this.getUpcomingEntranceExams();
    }
}
</script>

<style scoped>
    .wrap-column{
        max-width: 100px !important; 
        white-space: pre-wrap;
    }
</style>